import React from "react";
import { MessageCircle, Twitter, Facebook, Share2 } from "lucide-react";

const APP_URL = typeof window !== "undefined" ? window.location.origin : "";

export const ShareButtons = ({ text, label = "Share", compact = false }) => {
  const message = `${text}\n\n— Shabba Robo, your Naija know-it-all. Ask anything: ${APP_URL}`;
  const enc = encodeURIComponent(message);
  const encUrl = encodeURIComponent(APP_URL);

  const links = [
    { name: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${enc}`, color: "hover:text-[#25D366]" },
    { name: "X", icon: Twitter, href: `https://twitter.com/intent/tweet?text=${enc}`, color: "hover:text-ink" },
    { name: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${encUrl}&quote=${enc}`, color: "hover:text-[#1877F2]" },
  ];

  const nativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ text: message, url: APP_URL });
      } catch {}
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap" data-testid="share-buttons">
      {!compact && <span className="text-xs font-semibold text-ink/50 uppercase tracking-wider mr-1">{label}</span>}
      {links.map((l) => (
        <a
          key={l.name}
          href={l.href}
          target="_blank"
          rel="noopener noreferrer"
          className={`w-9 h-9 rounded-full border border-border bg-sand-light flex items-center justify-center text-ink/60 transition-colors ${l.color}`}
          title={`Share on ${l.name}`}
          data-testid={`share-${l.name.toLowerCase()}`}
        >
          <l.icon size={16} />
        </a>
      ))}
      {typeof navigator !== "undefined" && navigator.share && (
        <button
          onClick={nativeShare}
          className="w-9 h-9 rounded-full border border-border bg-sand-light flex items-center justify-center text-ink/60 hover:text-clay transition-colors"
          title="Share"
          data-testid="share-native"
        >
          <Share2 size={16} />
        </button>
      )}
    </div>
  );
};
